import {gsap, Observer} from "../LibrariesImport";
import {GlobalVariables} from "../GlobalVariables";

export default class Header {
	static init() {
		this.header = document.querySelector(".header-main");
		if (this.header) {
			this.navMain = this.header.querySelector(".navs");
			this.headerClass = this.header.className.replace("is-on-top", "");
			this.toggleHeader();
			this.resize();

		}
		GlobalVariables.resizeCallbacks.push(this);
	}

	static toggleHeader() {
		// let mm = gsap.matchMedia();
		// mm.add(`(min-width: ${mmMinWidth})`, () => {
		Observer.create({
			type: "scroll",
			tolerance: 60,
			dragMinimum: 10,
			onStop: () => {
				if (window.scrollY < 30) {
					this.header.className = this.headerClass;
					this.header.classList.add("is-on-top");
				} else {
					this.header.classList.remove("is-on-top");
				}
			},
			onStopDelay: 0,
			onUp: () => {
				this.showHeader();
			},
			onDown: () => {
				this.hideHeader();
			},
		});

		if (window.innerWidth > 991) {
			setTimeout(() => {
				if (window.scrollY > 100) {
					this.hideHeader();
				}
			}, 0);
		}
		// });
	}

	static hideHeader() {
		if (!document.body.classList.contains("navs-open") && !document.body.classList.contains("subnav-open")) {
			this.header.className = this.headerClass + " hide ";
		}
	}

	static showHeader() {
		this.header.classList.remove("hide");
	}

	static resize() {
		if (window.innerWidth > 991) {
			document.body.classList.remove("navs-open");
			GlobalVariables.lenis?.start();
		}
	}
}
